/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

export default function ModalVoidSuccess({
  modalOpenObj,
  voidResponse: rawVoidResponse,
  onStartNewSale,
  onFetchBillForPrint,
  onPrintBill,
  ...props
}) {
  const currencyFormat = useCallback((num) => {
    if (num === undefined || num === null) return "0.00";
    const numValue = typeof num === "string" ? parseFloat(num) : num;
    return numValue.toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }, []);

  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (
      modalOpenObj.modalOpen &&
      onFetchBillForPrint &&
      !hasCalledRef.current
    ) {
      hasCalledRef.current = true;
      onFetchBillForPrint();
    }

    if (!modalOpenObj.modalOpen) {
      hasCalledRef.current = false;
    }
  }, [modalOpenObj.modalOpen]);

  const handleStartNewSale = () => {
    onStartNewSale?.();
    modalOpenObj.setModalOpen(false);
  };

  const voidResponse = rawVoidResponse?.data ?? rawVoidResponse;
  if (!voidResponse) return null;

  const fmtInt = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

  const totalPointsBefore =
    voidResponse?.additional_data?.void_point?.total ?? 0;
  const spendPointsReturned = Math.abs(
    voidResponse?.additional_data?.void_point?.spend ?? 0
  );
  const earnedPoints = voidResponse?.additional_data?.void_point?.earned ?? 0;
  const totalPointsAfter =
    voidResponse?.additional_data?.void_point?.remain ?? 0;

  const methodName = voidResponse?.void_payment_method?.name || "-";
  const receiptNo = voidResponse?.receipt_no || "-";
  const voidNo = voidResponse?.void_no || "-";

  const totalBeforeDiscount = currencyFormat(
    voidResponse?.total_before_discount
  );
  const discountAmount = currencyFormat(voidResponse?.discount_amount);
  const totalAfterDiscount = currencyFormat(voidResponse?.total_after_discount);
  const amountPaid = currencyFormat(voidResponse?.final_payment_amount);
  const refundAmount = currencyFormat(voidResponse?.final_payment_amount);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={handleStartNewSale}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white position-relative focus-visible-none w-[min(90.11vw,905px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16 text-[var(--color-black-2)]">
            <div className="text-end absolute top-[10px] right-[10px]">
              <button
                className="btn btn-close-modal"
                onClick={handleStartNewSale}
              ></button>
            </div>

            <div className="p-[min(2.74vw,25px)]">
              <div className="mb-4 pb-2">
                <div className="d-flex align-items-center">
                  <div className="icon-succes-st-1 me-3"></div>
                  <div className="text-[#FF6B6B] fw-bold fs-24">
                    การ Void บิลเสร็จสิ้น
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <div
                    className="p-3"
                    style={{ borderRadius: "15px", background: "#FFF6F6" }}
                  >
                    <div className="d-flex tq-1 mb-4">
                      <div className="align-self-center me-auto text-[#FF6B6B] fw-bold">
                        ข้อมูลลูกค้า
                      </div>
                      <img
                        className="aspect-square w-[min(6.13vw,62px)] rounded-full object-cover"
                        src="/img/avatar-female.png"
                        alt=""
                      />
                    </div>

                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div>ชื่อลูกค้า</div>
                      <div>
                        {voidResponse?.member
                          ? `${voidResponse?.member?.first_name_th ?? ""} ${
                              voidResponse?.member?.last_name_th ?? ""
                            }`.trim() || "-"
                          : "-"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div>แต้มสะสมที่มีอยู่</div>
                      <div className="fw-light">
                        {fmtInt(totalPointsBefore)}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div>คืนแต้มสะสม</div>
                      <div className="fw-light">{spendPointsReturned}</div>
                    </div>

                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div>หักแต้มสะสม</div>
                      <div className="fw-light">{earnedPoints}</div>
                    </div>

                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div className="">
                        <span className="icon-star"></span> แต้มสะสมคงเหลือ
                      </div>
                      <div className="text-[#2DC76D] fw-bold">
                        {fmtInt(totalPointsAfter)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="d-flex mb-2">
                    <div className="align-self-center fw-500 text-[#061126] fs-18">
                      รายละเอียดการคืนเงิน
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">
                      ช่องทางการคืนเงิน
                    </div>
                    <div className="fs-18 text-[#2F4858]">{methodName}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">
                      เลขที่ใบเสร็จ
                    </div>
                    <div className="fs-18 text-[#2F4858]">{receiptNo}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">
                      เลขที่ Void
                    </div>
                    <div className="fs-18 text-[#2F4858]">{voidNo}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">ราคารวม</div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      {totalBeforeDiscount}
                      <span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">
                      ส่วนลดทั้งหมด
                    </div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      {discountAmount}
                      <span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">
                      ราคาสุทธิ
                    </div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      {totalAfterDiscount}
                      <span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">
                      จำนวนที่ชำระ
                    </div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      {amountPaid}
                      <span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>

                  <hr className="line-st1 my-3" style={{ opacity: 0.8 }} />
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-[#2DC76D] fs-24 fw-bold">
                      จำนวนเงินที่คืน
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        className="text-[#2DC76D] fs-30 fw-bold px-5 py-1"
                        style={{
                          borderRadius: "8px",
                          background: "rgba(45, 199, 109, 0.25)",
                        }}
                      >
                        {refundAmount}
                      </div>
                      <span className="fs-18 fw-500 text-[#00BC3A] ms-4">
                        THB
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr className="line-st1 mt-3 mb-0" style={{ opacity: 0.8 }} />
            <div className="d-flex justify-content-end p-4 my-2">
              <button className="btn btn-st4 me-3" onClick={onPrintBill}>
                Print
              </button>
              <button className="btn btn-st5" onClick={handleStartNewSale}>
                เสร็จสิ้น
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
